export default "__VITE_ASSET__ca6e341e__"